import classNames from 'classnames'
import { Link } from 'react-router-dom'

interface UnderLinkProps {
  label: string
  redirectTo: string
  isUnderline?: boolean
  className?: string
  state?: Record<string, unknown>
}

const UnderLink = ({
  label,
  redirectTo,
  isUnderline,
  className,
  state,
}: UnderLinkProps) => {
  return (
    <Link
      to={redirectTo}
      state={state}
      className={classNames(
        'inline-block',
        { underline: isUnderline },
        className
      )}
    >
      {label}
    </Link>
  )
}

export default UnderLink
